module.exports = __webpack_public_path__ + "amazon-ivs-wasmworker.min.wasm";